module.exports = __webpack_public_path__ + "media/images/ajax-loader-c5cd7f53.gif";